import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "Akkurat-Pro, Akkurat, Akkurat-Bold",
  },

  components: {


    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "Akkurat-Pro !important",
          textTransform: "none !important",
    
          // Apply font to all inner elements and fallback to button text
          "& *": {
            fontFamily: "Akkurat-Pro !important",
          },
          "&": {
            fontFamily: "Akkurat-Pro !important",
          }
        },
      },
    },
    
    
    
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "Akkurat-Pro",
        },
      },
    },

    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: "Akkurat-Pro",
        },
        input: {
          fontFamily: "Akkurat",
        },
      },
    },

    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: "Akkurat-Pro",
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: "Akkurat-Pro",
        },
      },
    }
  },
});

export default theme;
